import { apiClient } from './apiClient';

export const assetService = {
  // Get all assets
  async getAssets() {
    return apiClient.get(`/api/cmms/assets`);
  },

  // Get assets with pagination
  async getAssetsPaginated({ page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc', status, branchId, locationId, search }) {
    let url = `/api/cmms/assets/paginated?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`;
    if (status && status !== 'all') {
      url += `&status=${status}`;
    }
    if (branchId && branchId !== 'all') {
      url += `&branchId=${branchId}`;
    }
    if (locationId && locationId !== 'all') {
      url += `&locationId=${locationId}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return apiClient.get(url);
  },

  // Get single asset by ID
  async getAssetById(id) {
    return apiClient.get(`/api/cmms/assets/${id}`);
  },

  // Get assets by location
  async getAssetsByLocation(locationId) {
    return apiClient.get(`/api/cmms/assets/location/${locationId}`);
  },

  // Get assets by status
  async getAssetsByStatus(status) {
    return apiClient.get(`/api/cmms/assets/status/${status}`);
  },

  // Scan asset by QR code or barcode
  async scanAsset(code) {
    return apiClient.get(`/api/cmms/assets/scan/${code}`);
  },

  // Create new asset
  async createAsset(data) {
    const payload = {
      locationId: data.locationId ? parseInt(data.locationId) : null,
      parentAssetId: data.parentAssetId ? parseInt(data.parentAssetId) : null,
      supplierId: data.supplierId ? parseInt(data.supplierId) : null,
      name: data.name,
      assetTag: data.assetTag || null,
      category: data.category || null,
      type: data.type || null,
      manufacturer: data.manufacturer || null,
      model: data.model || null,
      serialNumber: data.serialNumber || null,
      purchaseDate: data.purchaseDate || null,
      purchaseCost: data.purchaseCost ? parseFloat(data.purchaseCost) : null,
      currentValue: data.currentValue ? parseFloat(data.currentValue) : null,
      usefulLifeYears: data.usefulLifeYears ? parseInt(data.usefulLifeYears) : null,
      depreciationMethod: data.depreciationMethod || null,
      salvageValue: data.salvageValue ? parseFloat(data.salvageValue) : null,
      status: data.status || 'OPERATIONAL',
      criticality: data.criticality || null,
      warrantyExpiration: data.warrantyExpiration || null,
      warrantyProvider: data.warrantyProvider || null,
      qrCode: data.qrCode || null,
      barcode: data.barcode || null,
      description: data.description || null,
      notes: data.notes || null,
      specifications: data.specifications || null
    };
    return apiClient.post(`/api/cmms/assets`, payload);
  },

  // Update asset
  async updateAsset(id, data) {
    const payload = {
      locationId: data.locationId ? parseInt(data.locationId) : null,
      parentAssetId: data.parentAssetId ? parseInt(data.parentAssetId) : null,
      supplierId: data.supplierId ? parseInt(data.supplierId) : null,
      name: data.name || null,
      category: data.category || null,
      type: data.type || null,
      manufacturer: data.manufacturer || null,
      model: data.model || null,
      serialNumber: data.serialNumber || null,
      purchaseDate: data.purchaseDate || null,
      purchaseCost: data.purchaseCost ? parseFloat(data.purchaseCost) : null,
      currentValue: data.currentValue ? parseFloat(data.currentValue) : null,
      usefulLifeYears: data.usefulLifeYears ? parseInt(data.usefulLifeYears) : null,
      depreciationMethod: data.depreciationMethod || null,
      salvageValue: data.salvageValue ? parseFloat(data.salvageValue) : null,
      status: data.status || null,
      criticality: data.criticality || null,
      warrantyExpiration: data.warrantyExpiration || null,
      warrantyProvider: data.warrantyProvider || null,
      qrCode: data.qrCode || null,
      barcode: data.barcode || null,
      description: data.description || null,
      notes: data.notes || null,
      specifications: data.specifications || null,
      isActive: data.isActive !== undefined ? data.isActive : null
    };
    return apiClient.put(`/api/cmms/assets/${id}`, payload);
  },

  // Update asset status
  async updateAssetStatus(id, status) {
    return apiClient.put(`/api/cmms/assets/${id}/status?status=${status}`);
  },

  // Delete asset
  async deleteAsset(id) {
    return apiClient.delete(`/api/cmms/assets/${id}`);
  },

  // Get maintenance history (work orders + visits) for an asset
  async getAssetMaintenanceHistory(id) {
    return apiClient.get(`/api/cmms/assets/${id}/maintenance-history`);
  }
};
